import { supabase } from './supabaseClient';

export async function getAllMetiers() {
  const { data, error } = await supabase
    .from('metiers')
    .select('*')
    .eq('is_active', true)
    .order('name', { ascending: true });

  if (error) throw error;
  return data || [];
}
